import * as ActionsTypes from "../../../common/state/StateConstants";
import { updateObject } from "../../../common/utils/FunctionsUtils";
const initialState = {
  error: null,
  errore: null,
  mfaErrorMessage: null,
  otpMailError: null,
  isLoading: false,
  titres: [],
  successMessage: null,
  titreDetail: [],
  isTitresLoading: false,
  allTitres: [],
  allTitresLoading: false,
  reponseDomiciliationBanqueData: { content: {} },
  reponseDomiciliationBanqueLoading: false,
  reponseDomiciliationBanqueError: false,
  searchTitreObject: {
    modeConsultation: false,
    tiDto: {
      numEnr: "",
      idEtat: "",
      idCategorie: "",
      idStatusModif: "",
      idTypeMessage: "",
      idReglement: "",
      idApurement: "",
      idBanque: "",
      idGuichet: "",
      idDeclarant: "",
      idNomenclature: "",
      idImportateur: "",
      nomenclatureNom: "",
      declarantNom: "",
      guichetNom: "",
      importateurNom: "",
      fromDateCreation: "",
      toDateCreation: "",
      refFact: "",
      numDom: "",
      fromDateDomiciliation: "",
      toDateDomiciliation: "",
    },
    pagination: {
      page: 0,
      pageSize: 10,
    },
  },
  etats: null,
  localites: null,
  categories: null,
  statusModif: null,
  typeMessages: null,
  banques: null,
  reglements: null,
  modeReglements: null,
  apurements: null,
  guichets: null,
  declarants: null,
  typeTE: null,
  typeTI: null,
  nomenclatures: null,
  importateurs: null,
  expandedSearchForm: false,
  isDecisionVisible: false,
  isDecisionMode: true,
  isDownloadLoading: false,
  isDecisionLoading: false,
  factureDocumentPdf: null,
  documentPdf: null,
  isHistoriqueLoading: false,
  historique: null,
  departments: [],
  decisionTypeMCE: [],
  decisionTypeMCEProlong: [],
  canTakeDecision: false,
  columnsState: {
    dateCreation: true,
    dateDomiciliation: true,
    categorie: true,
    devise: true,
    montant: true,
    importateur: true,
    declarant: true,
    etat: true,
    banqueDescription: true,
  },
  density: "standard",
  isEtatTableLoading: false,
  drawer: { open: true, width: 240 },
  kpi: null,
  isAuthenticated: false,
  token: null,
  qrCodeUrl: null,
  secret: null,
  requireOTP: null,
  message: null,
  enableMailMfa: null,
  passwordChangeError: null,
  passwordChangeSuccessMassage: null,
  isLoadingDomiciliation: false,
  hasErrorDomiciliation: false,
  isSuccessedDomiciliation: false,
  isLoadingRefusDomiciliation: false,
  isSuccessedRefusDomiciliation: false,
};

/*--------------------------------------------------GET-CHARGES----------------------------------------------------*/
const searchTitres = (state, action) => {
  return updateObject(state, {
    errore: null,
    searchTitreObject: action?.searchObject,
    expandedSearchForm: action?.expanded,
    isTitresLoading: true,
  });
};

const searchTitresSuccess = (state, action) => {
  return updateObject(state, {
    titres: action?.data,
    isTitresLoading: false,
  });
};

const searchTitresFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isTitresLoading: false,
  });
};

const setIsTiDecisionMode = (state, action) => {
  return updateObject(state, {
    isDecisionMode: action?.data,
  });
};

const getTiEtats = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getTiEtatsSuccess = (state, action) => {
  return updateObject(state, { etats: action?.data, isLoading: false });
};

const getTiEtatsFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const getTiLocalites = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getTiLocalitesSuccess = (state, action) => {
  return updateObject(state, { localites: action?.data, isLoading: false });
};

const getTiLocalitesFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const getTiGuichets = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getTiGuichetsSuccess = (state, action) => {
  return updateObject(state, { guichets: action?.data, isLoading: false });
};

const getTiGuichetsFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const getTiDeclarants = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getTiDeclarantsSuccess = (state, action) => {
  return updateObject(state, { declarants: action?.data, isLoading: false });
};

const getTiDeclarantsFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const getTiCategories = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getTiCategoriesSuccess = (state, action) => {
  return updateObject(state, { categories: action?.data, isLoading: false });
};

const getTiCategoriesFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const getTiStatusModif = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getTiStatusModifSuccess = (state, action) => {
  return updateObject(state, { statusModif: action?.data, isLoading: false });
};

const getTiStatusModifFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const getTiTypeMessage = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getTiTypeMessageSuccess = (state, action) => {
  return updateObject(state, { typeMessages: action?.data, isLoading: false });
};

const getTiTypeMessageFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const getTiBanque = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getTiBanqueSuccess = (state, action) => {
  return updateObject(state, { banques: action?.data, isLoading: false });
};

const getTiBanqueFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const getTypeReglement = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getTypeReglementSuccess = (state, action) => {
  return updateObject(state, { reglements: action?.data, isLoading: false });
};

const getTypeReglementFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const getModeReglement = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getModeReglementSuccess = (state, action) => {
  return updateObject(state, {
    modeReglements: action?.data,
    isLoading: false,
  });
};

const getModeReglementFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const getTiApurement = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getTiApurementSuccess = (state, action) => {
  return updateObject(state, { apurements: action?.data, isLoading: false });
};

const getTiApurementFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const getTiTypeTE = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getTiTypeTESuccess = (state, action) => {
  return updateObject(state, { typeTE: action?.data, isLoading: false });
};

const getTiTypeTEFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const getTiTypeTI = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getTiTypeTISuccess = (state, action) => {
  return updateObject(state, { typeTI: action?.data, isLoading: false });
};

const getTiTypeTIFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const getTiNomenclatures = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getTiNomenclaturesSuccess = (state, action) => {
  return updateObject(state, { nomenclatures: action?.data, isLoading: false });
};

const getTiNomenclaturesFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const getTiImportateurs = (state) => {
  return updateObject(state, { errore: null, isLoading: true });
};

const getTiImportateursSuccess = (state, action) => {
  return updateObject(state, { importateurs: action?.data, isLoading: false });
};

const getTiImportateursFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isLoading: false,
  });
};

const searchAllTitres = (state) => {
  return updateObject(state, { errore: null, allTitresLoading: true });
};

const searchAllTitresSuccess = (state, action) => {
  return updateObject(state, {
    AllTitres: action.data,
    allTitresLoading: false,
  });
};

const searchAllTitresFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    allTitresLoading: false,
  });
};

const getTi = (state) => {
  return updateObject(state, {
    successMessage: null,
    error: null,
    isLoading: true,
  });
};

const getTiSuccess = (state, action) => {
  return updateObject(state, {
    titreDetail: action.data,
    canTakeDecision: action?.data?.canTakeDecision,
    isLoading: false,
  });
};

const getTiFailure = (state, action) => {
  return updateObject(state, { error: action.error, isLoading: false });
};

const setIsDecisionTiVisible = (state, action) => {
  return updateObject(state, {
    isDecisionVisible: action.data,
  });
};

const downloadTi = (state) => {
  return updateObject(state, {
    errore: null,
    isDownloadLoading: true,
  });
};

const downloadTiSuccess = (state, action) => {
  return updateObject(state, {
    errore: null,
    isDownloadLoading: false,
  });
};

const downloadTiFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isDownloadLoading: false,
  });
};

const downloadTiFactureDocument = (state) => {
  return updateObject(state, {
    errore: null,
    factureDocumentPdf: null,
    isDownloadLoading: true,
  });
};

const downloadTiFactureDocumentSuccess = (state, action) => {
  return updateObject(state, {
    factureDocumentPdf: action.data === "DOWNLOAD" ? null : action.data,
    errore: null,
    isDownloadLoading: false,
  });
};

const downloadTiFactureDocumentFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isDownloadLoading: false,
  });
};

const downloadTiDocument = (state) => {
  return updateObject(state, {
    errore: null,
    documentPdf: null,
    isDownloadLoading: true,
  });
};

const downloadTiDocumentSuccess = (state, action) => {
  return updateObject(state, {
    documentPdf: action.data === "DOWNLOAD" ? null : action.data,
    errore: null,
    isDownloadLoading: false,
  });
};

const downloadTiDocumentFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isDownloadLoading: false,
  });
};

const getTiDecisionTypeMCEProlong = (state) => {
  return updateObject(state, {
    decisionTypeMCEProlong: [],
    error: null,
    isDecisionsLoading: true,
  });
};

const getTiDecisionTypeMCEProlongSuccess = (state, action) => {
  return updateObject(state, {
    decisionTypeMCEProlong: action.data,
    isDecisionsLoading: false,
  });
};

const getTiDecisionTypeMCEProlongFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isDecisionsLoading: false,
  });
};

const prolongMceTi = (state) => {
  return updateObject(state, {
    error: null,
    isDecisionLoading: true,
    successMessage: null,
  });
};

const prolongMceTiSuccess = (state, action) => {
  return updateObject(state, {
    successMessage: "Décision envoyée avec success",
    isDecisionVisible: false,
    isDecisionLoading: false,
  });
};

const prolongMceTiFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isDecisionVisible: false,
    isDecisionLoading: false,
  });
};

const clearTiHistorique = (state) => {
  return updateObject(state, {
    historique: null,
  });
};

const fetchTiHistorique = (state, action) => {
  return updateObject(state, {
    error: null,
    historique: null,
    isHistoriqueLoading: true,
  });
};

const fetchTiHistoriqueSuccess = (state, action) => {
  return updateObject(state, {
    historique: action.data,
    isHistoriqueLoading: false,
  });
};

const fetchTiHistoriqueFailure = (state, action) => {
  return updateObject(state, {
    historique: null,
    error: action.error,
    isHistoriqueLoading: false,
  });
};

const getTiDepartments = (state) => {
  return updateObject(state, {
    departments: [],
    error: null,
    isLoading: false,
  });
};

const getTiDepartmentsSuccess = (state, action) => {
  return updateObject(state, {
    departments: action.data,
    isLoading: false,
  });
};

const getTiDepartmentsFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isLoading: false,
  });
};

const transferTi = (state) => {
  return updateObject(state, {
    error: null,
    isDecisionLoading: true,
    successMessage: null,
  });
};

const transferTiSuccess = (state, action) => {
  return updateObject(state, {
    successMessage: "Le transfert est fait avec succès",
    isDecisionVisible: false,
    isDecisionLoading: false,
  });
};

const transferTiFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isDecisionVisible: false,
    isDecisionLoading: false,
  });
};

const transferTiProlong = (state) => {
  return updateObject(state, {
    error: null,
    isDecisionLoading: true,
    successMessage: null,
  });
};

const transferTiProlongSuccess = (state, action) => {
  return updateObject(state, {
    successMessage: "Le transfert est fait avec succès",
    isDecisionVisible: false,
    isDecisionLoading: false,
  });
};

const transferTiProlongFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isDecisionVisible: false,
    isDecisionLoading: false,
  });
};

const getTiDecisionType = (state) => {
  return updateObject(state, {
    decisionTypeMCE: [],
    error: null,
    isDecisionsLoading: true,
  });
};

const getTiDecisionTypeSuccess = (state, action) => {
  return updateObject(state, {
    decisionTypeMCE: action.data,
    isDecisionsLoading: false,
  });
};

const getTiDecisionTypeFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isDecisionsLoading: false,
  });
};

const decisionMceTi = (state) => {
  return updateObject(state, {
    error: null,
    isDecisionLoading: true,
    successMessage: null,
  });
};

const decisionMceTiSuccess = (state, action) => {
  return updateObject(state, {
    successMessage: "Décision envoyée avec success",
    isDecisionVisible: false,
    isDecisionLoading: false,
  });
};

const decisionMceTiFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isDecisionVisible: false,
    isDecisionLoading: false,
  });
};

const decisionDepTi = (state) => {
  return updateObject(state, {
    error: null,
    isDecisionLoading: true,
    successMessage: null,
  });
};

const decisionDepTiSuccess = (state, action) => {
  return updateObject(state, {
    successMessage: "Décision envoyée avec success",
    isDecisionVisible: false,
    isDecisionLoading: false,
  });
};

const decisionDepTiFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isDecisionVisible: false,
    isDecisionLoading: false,
  });
};

const prolongationDepTi = (state) => {
  return updateObject(state, {
    error: null,
    isDecisionLoading: true,
    successMessage: null,
  });
};

const prolongationDepTiSuccess = (state, action) => {
  return updateObject(state, {
    successMessage: "Décision envoyée avec success",
    isDecisionVisible: false,
    isDecisionLoading: false,
  });
};

const prolongationDepTiFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isDecisionVisible: false,
    isDecisionLoading: false,
  });
};

const setTiColumnsDensityState = (state, action) => {
  return updateObject(state, {
    columnsState: action.data.columnsState,
    density: action.data.density,
  });
};

const getTiColumnsDensityState = (state) => {
  return updateObject(state, {
    isEtatTableLoading: true,
  });
};

const getTiColumnsDensityStateSuccess = (state, action) => {
  const baseUpdate = { isEtatTableLoading: false };

  if (!action.data || action.data.id == null) {
    return updateObject(state, baseUpdate);
  }

  return updateObject(state, {
    ...baseUpdate,
    columnsState: action.data.columnsState,
    density: action.data.density,
  });
};

const getTiColumnsDensityStateFailure = (state, action) => {
  return updateObject(state, {
    isEtatTableLoading: false,
  });
};

const clearTiDetails = (state) => {
  return updateObject(state, {
    titreDetail: [],
    factureDocumentPdf: null,
    documentPdf: null,
    successMessage: null,
    errore: null,
  });
};

const clearTiErrors = (state) => {
  return updateObject(state, {
    errore: null,
    error: null,
  });
};

const clearTiSearchForm = (state) => {
  return updateObject(state, {
    searchTitreObject: {
      modeConsultation: false,
      tiDto: {
        numEnr: "",
        idEtat: "",
        idCategorie: "",
        idStatusModif: "",
        idTypeMessage: "",
        idReglement: "",
        idApurement: "",
        idBanque: "",
        idGuichet: "",
        idDeclarant: "",
        idNomenclature: "",
        idImportateur: "",
        nomenclatureNom: "",
        declarantNom: "",
        guichetNom: "",
        importateurNom: "",
        fromDateCreation: "",
        toDateCreation: "",
        refFact: "",
        numDom: "",
        fromDateDomiciliation: "",
        toDateDomiciliation: "",
      },
      pagination: {
        page: 0,
        pageSize: 10,
      },
    },
    titres: [],
    titreDetail: [],
    expandedSearchForm: false,
    error: null,
    errore: null,
  });
};

export const setDrawerState = (state, action) => {
  return updateObject(state, {
    drawer: action.data,
  });
};

const fetchKpiTi = (state, action) => {
  return updateObject(state, {
    error: null,
    kpi: null,
    isLoading: true,
  });
};

const fetchKpiTiSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    kpi: action.data,
    isLoading: false,
  });
};

const fetchKpiTiFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    kpi: null,
    isLoading: false,
  });
};

const authenticate = (state, action) => {
  return updateObject(state, {
    error: null,
    isLoading: true,
    qrCodeUrl: null,
    secret: null,
    mail: null,
    requireOTP: null,
    message: null,
    enableMailMfa: null,
  });
};

const authenticateSuccess = (state, action) => {
  const updateData = {
    mail: action.data.mail,
    qrCodeUrl: action.data.qrCodeUrl,
    secret: action.data.secret,
    requireOTP: action.data.requireOTP,
    message: action.data.message,
    enableMailMfa: action.data.enableMailMfa,
    isLoading: false,
  };

  if (action.data.token) {
    updateData.token = action.data.token;
  }

  return updateObject(state, updateData);
};

const authenticateFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isLoading: false,
    qrCodeUrl: null,
    secret: null,
    mail: null,
    requireOTP: null,
    message: null,
    enableMailMfa: null,
  });
};

const setIsAuthenticated = (state, action) => {
  if (!action.data) {
    return updateObject(state, {
      isAuthenticated: action.data,
      token: null,
      qrCodeUrl: null,
      secret: null,
      mail: null,
      requireOTP: null,
      message: null,
      enableMailMfa: null,
    });
  } else {
    return updateObject(state, {
      isAuthenticated: action.data,
    });
  }
};

const registerMFA = (state, action) => {
  return updateObject(state, { error: null, isLoading: true });
};

const registerMFASuccess = (state, action) => {
  return updateObject(state, {
    token: action.data?.token,
    isLoading: false,
    qrCodeUrl: null,
    secret: null,
    mail: null,
  });
};

const registerMFAFailure = (state, action) => {
  return updateObject(state, {
    mfaErrorMessage: action.error,
    isLoading: false,
  });
};

const sendOtpMail = (state, action) => {
  return updateObject(state, { error: null, isLoading: true });
};

const sendOtpMailSuccess = (state, action) => {
  return updateObject(state, {
    message: action.data.message,
    isLoading: false,
  });
};

const sendOtpMailFailure = (state, action) => {
  return updateObject(state, { otpMailError: action.error, isLoading: false });
};

const resetError = (state, action) => {
  return updateObject(state, { error: null });
};

const postChangePassword = (state) => {
  return updateObject(state, {
    passwordChangeError: null,
    passwordChangeSuccessMassage: null,
    isLoading: true,
  });
};

const postChangePasswordSuccess = (state, action) => {
  return updateObject(state, {
    passwordChangeSuccessMassage: action.data,
    isLoading: false,
  });
};

const postChangePasswordFailure = (state, action) => {
  return updateObject(state, {
    passwordChangeError: action.error,
    isLoading: false,
  });
};

const clearPasswordChange = (state) => {
  return updateObject(state, {
    passwordChangeError: null,
    passwordChangeSuccessMassage: null,
  });
};
/*--------------------------------------------------GET-REPONSE-DOMICILIATION-BANQUE-DATA----------------------------------------------------*/
const getReponseDomiciliationBanqueData = (state) => {
  return updateObject(state, {
    reponseDomiciliationBanqueLoading: true,
  });
};

const getReponseDomiciliationBanqueDataSuccess = (
  state,
  reponseDomiciliationBanqueData
) => {
  return updateObject(state, {
    reponseDomiciliationBanqueData,
    reponseDomiciliationBanqueLoading: false,
    reponseDomiciliationBanqueSuccess: true,
  });
};

const getReponseDomiciliationBanqueDataFail = (state, payload) => {
  return updateObject(state, {
    error: payload,
    reponseDomiciliationBanqueLoading: false,
    reponseDomiciliationBanqueError: true,
  });
};
/*--------------------------------------------------ACCEPT-DOMICILIATION-BANQUE-----------------------------------------------------*/
const acceptDomiciliationBanque = (state) => {
  return updateObject(state, {
    isLoadingDomiciliation: true,
  });
};

const acceptDomiciliationBanqueSuccess = (state, { content }) => {
  return updateObject(state, {
    content,
    isLoadingDomiciliation: false,
    isSuccessedDomiciliation: true,
  });
};

const acceptDomiciliationBanqueFail = (state, payload) => {
  return updateObject(state, {
    error: payload,
    isLoadingDomiciliation: false,
    hasErrorDomiciliation: true,
  });
};

const acceptDomiciliationBanqueReinitialization = (state) => {
  return updateObject(state, {
    error: null,
    isLoadingDomiciliation: false,
    hasErrorDomiciliation: false,
    isSuccessedDomiciliation: false,
  });
};
/*--------------------------------------------------REFUSE-DOMICILIATION-BANQUE----------------------------------------------------*/
const refuseDomiciliationBanque = (state) => {
  return updateObject(state, {
    isLoadingRefusDomiciliation: true,
  });
};

const refuseDomiciliationBanqueSuccess = (state, { content }) => {
  return updateObject(state, {
    content,
    isLoadingRefusDomiciliation: false,
    isSuccessedRefusDomiciliation: true,
  });
};

const refuseDomiciliationBanqueFail = (state, payload) => {
  return updateObject(state, {
    error: payload,
    isLoadingRefusDomiciliation: false,
  });
};

const refuseDomiciliationBanqueReinitialization = (state, payload) => {
  return updateObject(state, {
    isLoadingRefusDomiciliation: false,
    isSuccessedRefusDomiciliation: false,
  });
};

const postDonnesReglements = (state) => {
  return updateObject(state, {
    error: null,
    isDecisionLoading: true,
    successMessage: null,
  });
};

const postDonnesReglementsSuccess = (state, action) => {
  return updateObject(state, {
    successMessage: "Reglement envoyé avec succès",
    isDecisionLoading: false,
  });
};

const postDonnesReglementsFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isDecisionLoading: false,
  });
};

const resetState = (state) => {
  return updateObject(state, initialState);
};

export const TiReducer = (state = initialState, action) => {
  switch (action?.type) {
    case ActionsTypes.SEARCH_TITRE:
      return searchTitres(state, action);
    case ActionsTypes.SEARCH_TITRE_SUCCESS:
      return searchTitresSuccess(state, action);
    case ActionsTypes.SEARCH_TITRE_FAILURE:
      return searchTitresFailure(state, action);
    case ActionsTypes.FETCH_TI_ETATS:
      return getTiEtats(state);
    case ActionsTypes.FETCH_TI_ETATS_SUCCESS:
      return getTiEtatsSuccess(state, action);
    case ActionsTypes.FETCH_TI_ETATS_FAILURE:
      return getTiEtatsFailure(state, action);
    case ActionsTypes.FETCH_TI_CATEGORIES:
      return getTiCategories(state);
    case ActionsTypes.FETCH_TI_CATEGORIES_SUCCESS:
      return getTiCategoriesSuccess(state, action);
    case ActionsTypes.FETCH_TI_CATEGORIES_FAILURE:
      return getTiCategoriesFailure(state, action);
    case ActionsTypes.FETCH_TI_STATUS_MODIF:
      return getTiStatusModif(state);
    case ActionsTypes.FETCH_TI_STATUS_MODIF_SUCCESS:
      return getTiStatusModifSuccess(state, action);
    case ActionsTypes.FETCH_TI_STATUS_MODIF_FAILURE:
      return getTiStatusModifFailure(state, action);
    case ActionsTypes.FETCH_TI_TYPE_MESSAGE:
      return getTiTypeMessage(state);
    case ActionsTypes.FETCH_TI_TYPE_MESSAGE_SUCCESS:
      return getTiTypeMessageSuccess(state, action);
    case ActionsTypes.FETCH_TI_TYPE_MESSAGE_FAILURE:
      return getTiTypeMessageFailure(state, action);
    case ActionsTypes.FETCH_TI_BANQUE:
      return getTiBanque(state);
    case ActionsTypes.FETCH_TI_BANQUE_SUCCESS:
      return getTiBanqueSuccess(state, action);
    case ActionsTypes.FETCH_TI_BANQUE_FAILURE:
      return getTiBanqueFailure(state, action);
    case ActionsTypes.FETCH_TYPE_REGLEMENT:
      return getTypeReglement(state);
    case ActionsTypes.FETCH_TYPE_REGLEMENT_SUCCESS:
      return getTypeReglementSuccess(state, action);
    case ActionsTypes.FETCH_TYPE_REGLEMENT_FAILURE:
      return getTypeReglementFailure(state, action);
    case ActionsTypes.FETCH_MODE_REGLEMENT:
      return getModeReglement(state);
    case ActionsTypes.FETCH_MODE_REGLEMENT_SUCCESS:
      return getModeReglementSuccess(state, action);
    case ActionsTypes.FETCH_MODE_REGLEMENT_FAILURE:
      return getModeReglementFailure(state, action);
    case ActionsTypes.FETCH_TI_APUREMENT:
      return getTiApurement(state);
    case ActionsTypes.FETCH_TI_APUREMENT_SUCCESS:
      return getTiApurementSuccess(state, action);
    case ActionsTypes.FETCH_TI_APUREMENT_FAILURE:
      return getTiApurementFailure(state, action);
    case ActionsTypes.FETCH_TI_LOCALITES:
      return getTiLocalites(state);
    case ActionsTypes.FETCH_TI_LOCALITES_SUCCESS:
      return getTiLocalitesSuccess(state, action);
    case ActionsTypes.FETCH_TI_LOCALITES_FAILURE:
      return getTiLocalitesFailure(state, action);
    case ActionsTypes.FETCH_TI_GUICHETS:
      return getTiGuichets(state);
    case ActionsTypes.FETCH_TI_GUICHETS_SUCCESS:
      return getTiGuichetsSuccess(state, action);
    case ActionsTypes.FETCH_TI_GUICHETS_FAILURE:
      return getTiGuichetsFailure(state, action);
    case ActionsTypes.FETCH_TI_DECLARANTS:
      return getTiDeclarants(state);
    case ActionsTypes.FETCH_TI_DECLARANTS_SUCCESS:
      return getTiDeclarantsSuccess(state, action);
    case ActionsTypes.FETCH_TI_DECLARANTS_FAILURE:
      return getTiDeclarantsFailure(state, action);
    case ActionsTypes.FETCH_TI_TYPE_TE:
      return getTiTypeTE(state);
    case ActionsTypes.FETCH_TI_TYPE_TE_SUCCESS:
      return getTiTypeTESuccess(state, action);
    case ActionsTypes.FETCH_TI_TYPE_TE_FAILURE:
      return getTiTypeTEFailure(state, action);
    case ActionsTypes.FETCH_TI_TYPE_TI:
      return getTiTypeTI(state);
    case ActionsTypes.FETCH_TI_TYPE_TI_SUCCESS:
      return getTiTypeTISuccess(state, action);
    case ActionsTypes.FETCH_TI_TYPE_TI_FAILURE:
      return getTiTypeTIFailure(state, action);
    case ActionsTypes.FETCH_TI_NOMENCLATURES:
      return getTiNomenclatures(state);
    case ActionsTypes.FETCH_TI_NOMENCLATURES_SUCCESS:
      return getTiNomenclaturesSuccess(state, action);
    case ActionsTypes.FETCH_TI_NOMENCLATURES_FAILURE:
      return getTiNomenclaturesFailure(state, action);
    case ActionsTypes.FETCH_TI_IMPORTATEURS:
      return getTiImportateurs(state);
    case ActionsTypes.FETCH_TI_IMPORTATEURS_SUCCESS:
      return getTiImportateursSuccess(state, action);
    case ActionsTypes.FETCH_TI_IMPORTATEURS_FAILURE:
      return getTiImportateursFailure(state, action);
    case ActionsTypes.SEARCH_ALL_TITRES:
      return searchAllTitres(state, action);
    case ActionsTypes.SEARCH_ALL_TITRES_SUCCESS:
      return searchAllTitresSuccess(state, action);
    case ActionsTypes.SEARCH_ALL_TITRES_FAILURE:
      return searchAllTitresFailure(state, action);
    case ActionsTypes.SET_TI_DECISION_MODE:
      return setIsTiDecisionMode(state, action);
    case ActionsTypes.FETCH_TI:
      return getTi(state);
    case ActionsTypes.FETCH_TI_SUCCESS:
      return getTiSuccess(state, action);
    case ActionsTypes.FETCH_TI_FAILURE:
      return getTiFailure(state, action);
    case ActionsTypes.SET_DECISION_TI_VISIBLE:
      return setIsDecisionTiVisible(state, action);
    case ActionsTypes.DOWNLOAD_TI:
      return downloadTi(state);
    case ActionsTypes.DOWNLOAD_TI_SUCCESS:
      return downloadTiSuccess(state, action);
    case ActionsTypes.DOWNLOAD_TI_FAILURE:
      return downloadTiFailure(state, action);
    case ActionsTypes.DOWNLOAD_TI_FACTURE_DOCUMENT:
      return downloadTiFactureDocument(state);
    case ActionsTypes.DOWNLOAD_TI_FACTURE_DOCUMENT_SUCCESS:
      return downloadTiFactureDocumentSuccess(state, action);
    case ActionsTypes.DOWNLOAD_TI_FACTURE_DOCUMENT_FAILURE:
      return downloadTiFactureDocumentFailure(state, action);
    case ActionsTypes.DOWNLOAD_TI_DOCUMENT:
      return downloadTiDocument(state);
    case ActionsTypes.DOWNLOAD_TI_DOCUMENT_SUCCESS:
      return downloadTiDocumentSuccess(state, action);
    case ActionsTypes.DOWNLOAD_TI_DOCUMENT_FAILURE:
      return downloadTiDocumentFailure(state, action);
    case ActionsTypes.CLEAR_HISTORIQUE_TI:
      return clearTiHistorique(state);
    case ActionsTypes.FETCH_HISTORIQUE_TI:
      return fetchTiHistorique(state, action);
    case ActionsTypes.FETCH_HISTORIQUE_TI_SUCCESS:
      return fetchTiHistoriqueSuccess(state, action);
    case ActionsTypes.FETCH_HISTORIQUE_TI_FAILURE:
      return fetchTiHistoriqueFailure(state, action);
    case ActionsTypes.FETCH_DEPARTMENTS_TI:
      return getTiDepartments(state);
    case ActionsTypes.FETCH_DEPARTMENTS_TI_SUCCESS:
      return getTiDepartmentsSuccess(state, action);
    case ActionsTypes.FETCH_DEPARTMENTS_TI_FAILURE:
      return getTiDepartmentsFailure(state, action);
    case ActionsTypes.TRANSFER_TI:
      return transferTi(state);
    case ActionsTypes.TRANSFER_TI_SUCCESS:
      return transferTiSuccess(state, action);
    case ActionsTypes.TRANSFER_TI_FAILURE:
      return transferTiFailure(state, action);
    case ActionsTypes.TRANSFER_TI_PROLONG:
      return transferTiProlong(state);
    case ActionsTypes.TRANSFER_TI_PROLONG_SUCCESS:
      return transferTiProlongSuccess(state, action);
    case ActionsTypes.TRANSFER_TI_PROLONG_FAILURE:
      return transferTiProlongFailure(state, action);
    case ActionsTypes.FETCH_TI_TYPE_DECISION_MCE:
      return getTiDecisionType(state);
    case ActionsTypes.FETCH_TI_TYPE_DECISION_MCE_SUCCESS:
      return getTiDecisionTypeSuccess(state, action);
    case ActionsTypes.FETCH_TI_TYPE_DECISION_MCE_FAILURE:
      return getTiDecisionTypeFailure(state, action);
    case ActionsTypes.POST_TI_DECISION_MCE:
      return decisionMceTi(state);
    case ActionsTypes.POST_TI_DECISION_MCE_SUCCESS:
      return decisionMceTiSuccess(state, action);
    case ActionsTypes.POST_TI_DECISION_MCE_FAILURE:
      return decisionMceTiFailure(state, action);
    case ActionsTypes.POST_TI_DECISION_DEP:
      return decisionDepTi(state);
    case ActionsTypes.POST_TI_DECISION_DEP_SUCCESS:
      return decisionDepTiSuccess(state, action);
    case ActionsTypes.POST_TI_DECISION_DEP_FAILURE:
      return decisionDepTiFailure(state, action);
    case ActionsTypes.POST_TI_PROLONG_DEP:
      return prolongationDepTi(state);
    case ActionsTypes.POST_TI_PROLONG_DEP_SUCCESS:
      return prolongationDepTiSuccess(state, action);
    case ActionsTypes.POST_TI_PROLONG_DEP_FAILURE:
      return prolongationDepTiFailure(state, action);
    case ActionsTypes.FETCH_TI_TYPE_DECISION_MCE_PROLONG:
      return getTiDecisionTypeMCEProlong(state);
    case ActionsTypes.FETCH_TI_TYPE_DECISION_MCE_PROLONG_SUCCESS:
      return getTiDecisionTypeMCEProlongSuccess(state, action);
    case ActionsTypes.FETCH_TI_TYPE_DECISION_MCE_PROLONG_FAILURE:
      return getTiDecisionTypeMCEProlongFailure(state, action);
    case ActionsTypes.POST_TI_PROLONG_MCE:
      return prolongMceTi(state);
    case ActionsTypes.POST_TI_PROLONG_MCE_SUCCESS:
      return prolongMceTiSuccess(state, action);
    case ActionsTypes.POST_TI_PROLONG_MCE_FAILURE:
      return prolongMceTiFailure(state, action);
    case ActionsTypes.CLEAR_TITRE_DETIALS:
      return clearTiDetails(state);
    case ActionsTypes.CLEAR_TITRE_ERROR:
      return clearTiErrors(state);
    case ActionsTypes.CLEAR_TI_SEARCH_FORM:
      return clearTiSearchForm(state);
    case ActionsTypes.SET_TI_COLUMNS_DENSITY_STATE:
      return setTiColumnsDensityState(state, action);
    case ActionsTypes.GET_TI_COLUMNS_DENSITY_STATE:
      return getTiColumnsDensityState(state);
    case ActionsTypes.GET_TI_COLUMNS_DENSITY_STATE_SUCCESS:
      return getTiColumnsDensityStateSuccess(state, action);
    case ActionsTypes.GET_TI_COLUMNS_DENSITY_STATE_FAILURE:
      return getTiColumnsDensityStateFailure(state, action);
    case ActionsTypes.SET_DRAWER_STATE:
      return setDrawerState(state, action);
    case ActionsTypes.TI_KPI:
      return fetchKpiTi(state, action);
    case ActionsTypes.TI_KPI_SUCCESS:
      return fetchKpiTiSuccess(state, action);
    case ActionsTypes.TI_KPI_FAILURE:
      return fetchKpiTiFailure(state, action);
    /*--------------------------------------------------GET-REPONSE-DOMICILIATION-BANQUE-DATA---------------------------------------------------*/
    case ActionsTypes.GET_REPONSE_DOMICILIATION_BANQUE_DATA:
      return getReponseDomiciliationBanqueData(state);
    case ActionsTypes.GET_REPONSE_DOMICILIATION_BANQUE_DATA_SUCCESS:
      return getReponseDomiciliationBanqueDataSuccess(state, action.payload);
    case ActionsTypes.GET_REPONSE_DOMICILIATION_BANQUE_DATA_FAIL:
      return getReponseDomiciliationBanqueDataFail(state, action.payload);
    /*--------------------------------------------------ACCEPT-DOMICILIATION-BANQUE---------------------------------------------------*/
    case ActionsTypes.ACCEPT_DOMICILIATION_BANQUE:
      return acceptDomiciliationBanque(state);
    case ActionsTypes.ACCEPT_DOMICILIATION_BANQUE_SUCCESS:
      return acceptDomiciliationBanqueSuccess(state, action.payload);
    case ActionsTypes.ACCEPT_DOMICILIATION_BANQUE_FAIL:
      return acceptDomiciliationBanqueFail(state, action.payload);
    case ActionsTypes.ACCEPT_DOMICILIATION_BANQUE_REINITIALIZATION:
      return acceptDomiciliationBanqueReinitialization(state);
    /*--------------------------------------------------REFUSE-DOMICILIATION-BANQUE---------------------------------------------------*/
    case ActionsTypes.REFUSE_DOMICILIATION_BANQUE:
      return refuseDomiciliationBanque(state);
    case ActionsTypes.REFUSE_DOMICILIATION_BANQUE_SUCCESS:
      return refuseDomiciliationBanqueSuccess(state, action.payload);
    case ActionsTypes.REFUSE_DOMICILIATION_BANQUE_FAIL:
      return refuseDomiciliationBanqueFail(state, action.payload);
    case ActionsTypes.REFUSE_DOMICILIATION_BANQUE_REINITIALIZATION:
      return refuseDomiciliationBanqueReinitialization(state, action.payload);
    case ActionsTypes.POST_DONNEES_REGLEMENT:
      return postDonnesReglements(state);
    case ActionsTypes.POST_DONNEES_REGLEMENT_SUCCESS:
      return postDonnesReglementsSuccess(state, action);
    case ActionsTypes.POST_DONNEES_REGLEMENT_FAILURE:
      return postDonnesReglementsFailure(state, action);
    case ActionsTypes.RESET_STATE:
      return resetState(state);
    default:
      return state;
  }
};

export const AuthentificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionsTypes.AUTHENTICATE_USER:
      return authenticate(state, action);
    case ActionsTypes.AUTHENTICATE_USER_SUCCESS:
      return authenticateSuccess(state, action);
    case ActionsTypes.AUTHENTICATE_USER_FAILURE:
      return authenticateFailure(state, action);
    case ActionsTypes.SET_IS_AUTHENTICATED:
      return setIsAuthenticated(state, action);
    case ActionsTypes.REGISTER_MFA:
      return registerMFA(state, action);
    case ActionsTypes.REGISTER_MFA_SUCCESS:
      return registerMFASuccess(state, action);
    case ActionsTypes.REGISTER_MFA_FAILURE:
      return registerMFAFailure(state, action);
    case ActionsTypes.SEND_OTP_MAIL:
      return sendOtpMail(state, action);
    case ActionsTypes.SEND_OTP_MAIL_SUCCESS:
      return sendOtpMailSuccess(state, action);
    case ActionsTypes.SEND_OTP_MAIL_FAILURE:
      return sendOtpMailFailure(state, action);
    case ActionsTypes.RESET_ERROR:
      return resetError(state, action);
    case ActionsTypes.POST_CHANGE_PASSWORD:
      return postChangePassword(state);
    case ActionsTypes.POST_CHANGE_PASSWORD_SUCCESS:
      return postChangePasswordSuccess(state, action);
    case ActionsTypes.POST_CHANGE_PASSWORD_FAILURE:
      return postChangePasswordFailure(state, action);
    case ActionsTypes.CLEAR_CHANGE_PASSWORD:
      return clearPasswordChange(state);
    default:
      return state;
  }
};
